/**
 * This file holds actions. The actions commit mutations and can perform asynchronous operations.
 * Please refer to https://vuex.vuejs.org/guide/actions.html for more information
 */
import http from "@/http";
import * as types from "./types";
import returnUrlParams from "@/http/returnUrlParams";

const actions = {
  [types.UPLOAD_PLACEMENT](
    context,
    { componentName, productName, tonalstitch, size, placements }
  ) {
    const body = { componentName, productName, size, placements };
    if (tonalstitch) body.tonalstitch = tonalstitch;
    const data = new FormData();
    data.append("bodyPayload", JSON.stringify(body));

    const requestUrl = `${context.rootState.endPoints.customizer.placementImage}`;

    return http.post(requestUrl, data);
  }
};

export default actions;
